import { Home } from '@/pages/Home'
import { buildMeta } from '@/lib/metaTags'

export function meta() {
  return buildMeta({
    title: 'Skillo Academy | AI Agent, Web Development & Practical Tech Courses in Sylhet',
    description:
      'Join Skillo Academy’s live Bangla + English courses in Sylhet, Bangladesh. Learn AI Agent Building, Full Stack Web Development, automation, portfolio projects, and practical career skills — without income guarantees.',
    path: '/',
  })
}

export default Home
